<div style="position: relative;" fxFlexFill>

    <div [style.display]="element.reading ? 'none' : null" fxFlexFill>
        <video *ngIf="element.contentType == ContentType.VIDEO" [src]="element.src" style="width: 100%;" (loadeddata)="element.reading = false;"></video>
        <img *ngIf="element.contentType == ContentType.IMAGE" [src]="element.src" style="width: 100%;" (load)="element.reading = false;" />
        <img *ngIf="element.contentType == ContentType.MODEL" src="../../assets/images/CUBE-VECTOR (2).png" style="width: 100%;" (load)="element.reading = false;" />
        <!-- <img *ngIf="element.contentType == ContentType.ZIP" src="../../assets/images/zip_new.png" style="width: 100%;" (load)="element.reading = false;" /> -->
        <!-- <iframe type="text/html" style="width:100%; height: 100%" *ngIf="element.contentType == ContentType.MODEL" src="../../assets/images/test.png" frameborder="0"></iframe> -->
        <iframe type="text/html" style="width:100%; height: 100%" *ngIf="element.contentType == ContentType.STREAM_YOUTUBE || element.contentType == ContentType.STREAM_VIMEO" [src]="element.src" frameborder="0"></iframe>
    </div>

    <div *ngIf="element.reading || element.uploading || element.deleting" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; background: rgba(255,255,255, 0.8)">
        <div fxFlexFill fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0.5rem">

            <ng-container *ngIf="!element.reading">
                <ng-container *ngIf="element.uploading && !element.deleting">
                    <div *ngIf="element.contentType == ContentType.STREAM_YOUTUBE || element.contentType == ContentType.STREAM_VIMEO">
                        Adding...
                    </div>
                    <div *ngIf="element.contentType == ContentType.VIDEO || element.contentType == ContentType.IMAGE || element.contentType == ContentType.MODEL">
                        Uploading...
                    </div>
                    <div style="position: relative;">
                        <mat-progress-spinner mode='determinate' [value]="element.uploadProgress" [diameter]="50"></mat-progress-spinner>
                        <div style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" *ngIf="element.contentType == ContentType.VIDEO || element.contentType == ContentType.IMAGE || element.contentType == ContentType.MODEL">
                            <div fxFlexFill fxLayout="column" fxLayoutAlign="center center">
                                <button mat-mini-fab color="warn" (click)="element.cancelUpload()">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="element.deleting">
                    <div *ngIf="!element.uploading">Deleting...</div>
                    <div *ngIf="element.uploading">Cancelling...</div>
                    <mat-spinner [diameter]="50"></mat-spinner>
                </ng-container>

            </ng-container>

            <div *ngIf="element.reading">
                <mat-spinner [diameter]="50"></mat-spinner>
            </div>

        </div>
    </div>
</div>